import React from "react";
import BookingDetailsSidebar from "./BookingDetailsSidebar";
import "./BookingDetailsOffcanvas.css";

/**
 * The slide-in Booking Details panel.
 *
 * Both the bookings list and the dashboard's Recent Bookings open the same
 * panel, so the shell (drawer, header, backdrop) lives here rather than being
 * duplicated per screen — a change to the chrome then applies to both.
 *
 * `onUpdate` fires after a status change so the host screen can refresh the
 * rows behind the panel.
 */
const BookingDetailsOffcanvas = ({ bookingId, show, onClose, onUpdate }) => (
    <>
        <div
            className={`offcanvas offcanvas-end booking-offcanvas ${show ? "show" : ""}`}
            tabIndex="-1"
            style={{ visibility: show ? "visible" : "hidden", width: 460 }}
        >
            <div className="offcanvas-header">
                <h5 className="offcanvas-title">Booking Details</h5>
                <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>
            <div className="offcanvas-body booking-offcanvas-body">
                {bookingId && (
                    <BookingDetailsSidebar
                        bookingId={bookingId}
                        onUpdate={onUpdate}
                    />
                )}
            </div>
        </div>

        {show && <div className="offcanvas-backdrop fade show" onClick={onClose}></div>}
    </>
);

export default BookingDetailsOffcanvas;
